import React, { useState } from 'react';
import { ArrowUpRight, ArrowRight, Menu, X } from 'lucide-react';
interface NavBarProps {
  currentPage: string;
  onNavigate: (page: string) => void;
}
function FlipText({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  const rowHeight = 16;
  return <span className={`inline-block overflow-hidden align-middle ${className}`} style={{
    height: rowHeight
  }} data-id="element-49">
      <span className="flex flex-col" style={{
      transition: 'transform 0.35s cubic-bezier(0.65, 0, 0.35, 1)'
    }} onMouseEnter={e => {
      ;
      (e.currentTarget as HTMLElement).style.transform = `translateY(-${rowHeight}px)`;
    }} onMouseLeave={e => {
      ;
      (e.currentTarget as HTMLElement).style.transform = 'translateY(0)';
    }} data-id="element-50">
        <span className="inline-block" style={{
        height: rowHeight,
        lineHeight: `${rowHeight}px`
      }} data-id="element-51">
          {children}
        </span>
        <span className="inline-block" style={{
        height: rowHeight,
        lineHeight: `${rowHeight}px`
      }} data-id="element-52">
          {children}
        </span>
      </span>
    </span>;
}
export function NavBar({
  currentPage,
  onNavigate
}: NavBarProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navFont = "'Helvetica Neue', Helvetica, Arial, sans-serif";
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const handleMobileNavigate = (page: string) => {
    onNavigate(page);
    setIsMenuOpen(false);
  };
  return <header className="top-0 left-0 right-0 z-50 bg-white relative" data-id="element-53">
      {/* Logo Section - Clickable to go home */}
      <div className="flex justify-center items-center px-4 md:px-10 -my-8 md:-my-14 cursor-pointer" onClick={() => onNavigate('home')} data-id="element-54">
        <img src="https://cdn.magicpatterns.com/uploads/7xVT2hP9DurH35u37FvRoK/Untitled_(Instagram_Post)_(4).png" alt="Post-Strangers by Nomad Citizen x Plumia" className="h-[160px] md:h-[280px] object-contain transition-all duration-300" data-id="element-55" />
      </div>

      {/* Mobile Menu Button - Absolute positioned to align with nav row visually */}
      <div className="md:hidden absolute right-4 top-8 z-50" data-id="element-56">
        <button onClick={toggleMenu} className="p-2" data-id="element-57">
          {isMenuOpen ? <X className="w-6 h-6 text-black" data-id="element-58" /> : <Menu className="w-6 h-6 text-black" data-id="element-59" />}
        </button>
      </div>

      {/* Navigation Row - Desktop */}
      <nav className="hidden md:flex items-center justify-between mx-12 px-0 py-6 border-t border-black/10" style={{
      fontFamily: navFont
    }} data-id="element-60">
        {/* Left nav links */}
        <div className="flex items-center" style={{
        gap: '3.5rem'
      }} data-id="element-61">
          <button onClick={() => onNavigate('about')} className={`text-[13px] font-medium tracking-[0.15em] whitespace-nowrap ${currentPage === 'about' ? 'text-gray-400' : 'text-black'}`} data-id="element-62">
            <FlipText data-id="element-63">ABOUT</FlipText>
          </button>
          <button onClick={() => onNavigate('dinners')} className={`text-[13px] font-medium tracking-[0.15em] whitespace-nowrap ${currentPage === 'dinners' ? 'text-gray-400' : 'text-black'}`} data-id="element-64">
            <FlipText data-id="element-65">DINNERS</FlipText>
          </button>
          <a href="https://www.notion.so/safetywing/Nomad-Citizen-Product-Info-1ba73e1ca3428079bd3fe36d52eb2161" target="_blank" rel="noopener noreferrer" className="group flex items-center text-[13px] font-medium tracking-[0.15em] text-black whitespace-nowrap" data-id="element-66">
            <FlipText data-id="element-67">MANIFESTO</FlipText>
          </a>
          <a href="https://safetywing.com/nomad-citizen" target="_blank" rel="noopener noreferrer" className="group flex items-center text-[13px] font-medium tracking-[0.15em] text-black whitespace-nowrap" style={{
          borderBottom: '1px solid black',
          paddingBottom: '2px'
        }} data-id="element-68">
            <FlipText data-id="element-69">MEMBERSHIP</FlipText>
            <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" data-id="element-70" />
          </a>
        </div>

        {/* Spacer */}
        <div className="flex-1" data-id="element-71" />

        {/* Right social links */}
        <div className="flex items-center" style={{
        gap: '2.5rem'
      }} data-id="element-72">
          <a href="https://www.instagram.com/wearepoststrangers/" target="_blank" rel="noopener noreferrer" className="flex items-center text-[12px] font-medium tracking-[0.15em] text-black whitespace-nowrap" data-id="element-73">
            <FlipText data-id="element-74">Instagram</FlipText>
            <ArrowUpRight className="ml-1 w-3.5 h-3.5" data-id="element-75" />
          </a>
          <a href="#" className="flex items-center text-[12px] font-medium tracking-[0.15em] text-black whitespace-nowrap" data-id="element-76">
            <FlipText data-id="element-77">Whatsapp</FlipText>
            <ArrowUpRight className="ml-1 w-3.5 h-3.5" data-id="element-78" />
          </a>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      {isMenuOpen && <div className="fixed inset-0 bg-white z-40 flex flex-col pt-32 px-8 md:hidden" style={{
      fontFamily: navFont
    }} data-id="element-79">
          <div className="flex flex-col gap-8 items-start" data-id="element-80">
            <button onClick={() => handleMobileNavigate('about')} className={`text-[24px] font-medium tracking-[0.05em] ${currentPage === 'about' ? 'text-gray-400' : 'text-black'}`} data-id="element-81">
              ABOUT
            </button>
            <button onClick={() => handleMobileNavigate('dinners')} className={`text-[24px] font-medium tracking-[0.05em] ${currentPage === 'dinners' ? 'text-gray-400' : 'text-black'}`} data-id="element-82">
              DINNERS
            </button>
            <a href="https://www.notion.so/safetywing/Nomad-Citizen-Product-Info-1ba73e1ca3428079bd3fe36d52eb2161" target="_blank" rel="noopener noreferrer" className="text-[24px] font-medium tracking-[0.05em] text-black" data-id="element-83">
              MANIFESTO
            </a>
            <a href="https://safetywing.com/nomad-citizen" target="_blank" rel="noopener noreferrer" className="text-[24px] font-medium tracking-[0.05em] text-black flex items-center" data-id="element-84">
              MEMBERSHIP
              <ArrowRight className="ml-2 w-5 h-5" data-id="element-85" />
            </a>
          </div>

          <div className="mt-auto mb-12 flex flex-col gap-6" data-id="element-86">
            <a href="https://www.instagram.com/wearepoststrangers/" target="_blank" rel="noopener noreferrer" className="flex items-center text-[16px] font-medium tracking-[0.05em] text-black" data-id="element-87">
              Instagram <ArrowUpRight className="ml-1 w-4 h-4" data-id="element-88" />
            </a>
            <a href="#" className="flex items-center text-[16px] font-medium tracking-[0.05em] text-black" data-id="element-89">
              Whatsapp <ArrowUpRight className="ml-1 w-4 h-4" data-id="element-90" />
            </a>
          </div>
        </div>}
    </header>;
}